import React, { useEffect, useState } from "react";
import BriefingTable from "../subcomponents/table";
import { TextField, SelectField, Checkbox } from "../subcomponents/fields";
import { fetchRows } from "../helpers";
import { CRUDRow } from "../helpers";
import Actions from "../subcomponents/actions";
import HistoryViewer from "../subcomponents/historyViewer";
import { useSelector } from "react-redux";

const Hotboard = () => {
    const [hotBoard, setHotBoard] = useState([]);

    const briefing = useSelector((state) => state.briefing.line);
    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);
    
    const requestPayload = {
        "startDate": startDate,
        "endDate": endDate,
        "searchTerm": searchTerm
    }

    const DataURL = "admin/briefing/get_hotboard";
    const RowURL = "admin/briefing/hotboard_row";

    useEffect(() => {
        (async () => {
            const data = await fetchRows(DataURL, briefing, requestPayload);
            setHotBoard(data);
        })();
    }, [startDate, endDate, searchTerm, briefing]);

    // Function to create a new row and refresh the table
    const CRUDHotboardRow = async (action = "create", rowID = null) => {
        await CRUDRow(RowURL, action, rowID);
        // Re-fetch data after modifying the row
        const data = await fetchRows(DataURL);
        setHotBoard(data);
    };

    const possibleStatuses = [
        "En route to shipper",
        "On site shipper",
        "Pending loaded",
        "En route to consignee",
        "On site consignee",
        "Pending offloaded"
    ];

    const headers = [
        "ID",
        "Pro #",
        "Driver(s) / Carrier",
        "Load Status",
        "Pro Note?",
        "Notes",
        "Act."
    ];

    const renderRow = (row) => (
        <tr key={row.id}>
            <td className="row-id-cell">
                <div className="row-id-div">
                    {row.id}
                </div>
            </td>
            <td style={{ width: "15%" }}>
                <TextField field={row.pro} />
            </td>
            <td style={{ width: "20%" }}>
                <TextField field={row.drivers_or_carrier} />
            </td>
            <td style={{ width: "14%" }}>
                <SelectField field={row.status}>
                    {possibleStatuses.map((stage, index) => (
                        <option key={index}>{stage}</option>
                    ))}
                </SelectField>
            </td>
            <td className="checkbox-cell">
                <Checkbox field={row.pronote_added} />
            </td>
            <td>
                <TextField field={row.note} />
            </td>
            <td className="actions-cell">
                <Actions
                    onDelete={() => CRUDHotboardRow("delete", row.id)} // Wrap in a function
                    onArchive={() => CRUDHotboardRow("archive", row.id)} // Wrap in a function
                />
            </td>
        </tr>
    );

    if (briefing === "Old Briefings" && !hotBoard.length) {
        return null
    }

    return (
        <>
            <div className="table-header">
                <h2>
                    Hotboard
                </h2>
                <HistoryViewer
                    url={DataURL}
                />
            </div>
            <BriefingTable
                headers={headers}
                rows={hotBoard}
                renderRow={renderRow}
                createRow={CRUDHotboardRow}
            />
        </>
    );
};

export default Hotboard;
